// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q3aIxZPzz6 {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.Q3aIxZPzz6 h4 {
  line-height: 3em;
}
.Q3aIxZPzz6 .rVKgH2bB8L {
  float: left;
  width: 100%;
}
.Q3aIxZPzz6 .CS_tc9NaAP {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.Q3aIxZPzz6 .CS_tc9NaAP:hover {
  cursor: pointer;
}
.Q3aIxZPzz6 .CS_tc9NaAP:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.Njk84APovI .ZBHD4dQCmy:focus {
  outline: none;
}
.Njk84APovI .ZBHD4dQCmy.WUfnJFY0lS.nMF_zNcC8y {
  background: #375A88;
}
.Njk84APovI .ZBHD4dQCmy.WUfnJFY0lS.nMF_zNcC8y span {
  color: #fff;
}
.Njk84APovI .nMF_zNcC8y {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.Njk84APovI .nMF_zNcC8y:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.Njk84APovI input {
  height: 38px;
  min-width: 220px;
}
.CS_tc9NaAP.Pmb_upNSc5 {
  background: #410102;
}
.CS_tc9NaAP.hEEsFswruy {
  background: #911318;
}
.CS_tc9NaAP.NGIScGGTkh {
  background: #D8293B;
}
.CS_tc9NaAP.b7WEyS5idY {
  background: #F2373C;
}
.CS_tc9NaAP.i222cJZW9U {
  background: #FC4448;
}
.CS_tc9NaAP.iNuzPGRCWm {
  background: #ED535E;
}
.CS_tc9NaAP.yISMwdT6U8 {
  background: #E34926;
}
.CS_tc9NaAP.nuIDckwlCI {
  background: #FC562B;
}
.CS_tc9NaAP.VZkwazJcH6 {
  background: #FC6722;
}
.CS_tc9NaAP.ql9yeM3FDf {
  background: #FD7F24;
}
.CS_tc9NaAP.BeNJHE5xpV {
  background: #FD8D26;
}
.CS_tc9NaAP.YRzMwJVq7Z {
  background: #EC9C3E;
}
.CS_tc9NaAP.BZj1GT8sDw {
  background: #0e673a;
}
.CS_tc9NaAP.qqoF3BCpvF {
  background: #208740;
}
.CS_tc9NaAP.j6QAWFUZgf {
  background: #239718;
}
.CS_tc9NaAP.EHUjo8SuFW {
  background: #55A84D;
}
.CS_tc9NaAP.NYMj9FPmlF {
  background: #4BBE5A;
}
.CS_tc9NaAP.cMN8PHjo3H {
  background: #0CCA6A;
}
.CS_tc9NaAP.dyMqGY5YrQ {
  background: #0A3C64;
}
.CS_tc9NaAP.WM20WZK9tR {
  background: #0d487a;
}
.CS_tc9NaAP.jTZSPInd3J {
  background: #10538d;
}
.CS_tc9NaAP.aopwWk0qZ1 {
  background: #115A99;
}
.CS_tc9NaAP.fYlS5BPoF9 {
  background: #3387E2;
}
.CS_tc9NaAP.jmQ6w5BnU8 {
  background: #1BA9CF;
}
.CS_tc9NaAP.grNkhl1jPs {
  background: #d27c02;
}
.CS_tc9NaAP.hLcV2U9K3s {
  background: #fb9402;
}
.CS_tc9NaAP.TFYsnnDYOs {
  background: #FD9B30;
}
.CS_tc9NaAP.AyhOwiNyvR {
  background: #FDBE2D;
}
.CS_tc9NaAP.Wn0pwJ0_QC {
  background: #FED831;
}
.CS_tc9NaAP.gVPZO6GMZo {
  background: #FFFD38;
}
.CS_tc9NaAP.ItmDHh3mW0 {
  background: #2D215C;
}
.CS_tc9NaAP.lIuNQNPHBP {
  background: #483C83;
}
.CS_tc9NaAP.Va4xaF_0Md {
  background: #58518d;
}
.CS_tc9NaAP.fhoQrasGZG {
  background: #7068A9;
}
.CS_tc9NaAP.MmwFqb1oSv {
  background: #7f78b2;
}
.CS_tc9NaAP.Xbyb6x8e2R {
  background: #8f88bc;
}
.CS_tc9NaAP.pznfI2X3BY {
  background: #000;
}
.CS_tc9NaAP.OPkm3Xivq9 {
  background: #282626;
}
.CS_tc9NaAP.lAKYy4AG2L {
  background: #242222;
}
.CS_tc9NaAP.nCv76CsBtE {
  background: #353838;
}
.CS_tc9NaAP.xlJP4XETdH {
  background: #666;
}
.CS_tc9NaAP.jtwbIGp_pZ {
  background: #999;
}
.r_uehcoZBs {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.r_uehcoZBs .hHFvb3BWsO {
  display: none;
}
.RYHQTH10NW {
  background-color: #375A87;
}
.RYHQTH10NW .JQ0RODxDbv {
  font-size: 32px;
}
.RYHQTH10NW .UV__gLNk9W.UV__gLNk9W.UV__gLNk9W {
  font-size: 20px;
}
.MJ3fHrYQmo.MJ3fHrYQmo {
  height: 600px;
  width: 1048px;
  max-width: 1048px;
}
.XsezbgaYew.XsezbgaYew {
  padding: 24px !important;
}
.XsezbgaYew.XsezbgaYew::-webkit-scrollbar {
  width: 8px;
}
.XsezbgaYew.XsezbgaYew::-webkit-scrollbar-thumb {
  background: #939393;
  border-radius: 4px;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE {
  margin-bottom: 8px;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE .gvP1JrEFWE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE .uyjxWlkbVx {
  display: flex;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE .uyjxWlkbVx .rKUdE4Lrlv {
  font-size: 11px;
  text-transform: uppercase;
  margin-bottom: 0;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE .uyjxWlkbVx .AeSin2D8EH {
  margin-left: 12px;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE .uyjxWlkbVx .AeSin2D8EH .g9AjJvDGCn {
  font-size: 12px;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE .gvP1JrEFWE .xeV_oAt0GH {
  font-size: 11px;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE .WQm7AGmeus {
  border-width: 1px;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE .e88Nd8waC_ {
  border-color: #DB383B;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE ._aiWiUSBG2 {
  min-height: 75px;
  resize: none;
  border: #e1e8ed 1px solid;
  margin-bottom: 0;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE .sw_LiLcjfw {
  border-color: #DB383B;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE ._aiWiUSBG2::placeholder {
  opacity: 0.42;
}
.XsezbgaYew.XsezbgaYew .GkJECQSelE .B057YWZlWq {
  font-size: 11px;
  font-weight: 300;
  color: #D93A40;
}
.XsezbgaYew.XsezbgaYew ._BK1mppXqz {
  font-size: 11px;
  margin-bottom: 0;
  text-transform: uppercase;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `Q3aIxZPzz6`,
	"color-row": `rVKgH2bB8L`,
	"color-tile": `CS_tc9NaAP`,
	"picker-component": `Njk84APovI`,
	"picker-element": `ZBHD4dQCmy`,
	"active": `WUfnJFY0lS`,
	"btn": `nMF_zNcC8y`,
	"red-1": `Pmb_upNSc5`,
	"red-2": `hEEsFswruy`,
	"red-3": `NGIScGGTkh`,
	"red-4": `b7WEyS5idY`,
	"red-5": `i222cJZW9U`,
	"red-6": `iNuzPGRCWm`,
	"orange-1": `yISMwdT6U8`,
	"orange-2": `nuIDckwlCI`,
	"orange-3": `VZkwazJcH6`,
	"orange-4": `ql9yeM3FDf`,
	"orange-5": `BeNJHE5xpV`,
	"orange-6": `YRzMwJVq7Z`,
	"green-1": `BZj1GT8sDw`,
	"green-2": `qqoF3BCpvF`,
	"green-3": `j6QAWFUZgf`,
	"green-4": `EHUjo8SuFW`,
	"green-5": `NYMj9FPmlF`,
	"green-6": `cMN8PHjo3H`,
	"blue-1": `dyMqGY5YrQ`,
	"blue-2": `WM20WZK9tR`,
	"blue-3": `jTZSPInd3J`,
	"blue-4": `aopwWk0qZ1`,
	"blue-5": `fYlS5BPoF9`,
	"blue-6": `jmQ6w5BnU8`,
	"yellow-1": `grNkhl1jPs`,
	"yellow-2": `hLcV2U9K3s`,
	"yellow-3": `TFYsnnDYOs`,
	"yellow-4": `AyhOwiNyvR`,
	"yellow-5": `Wn0pwJ0_QC`,
	"yellow-6": `gVPZO6GMZo`,
	"purple-1": `ItmDHh3mW0`,
	"purple-2": `lIuNQNPHBP`,
	"purple-3": `Va4xaF_0Md`,
	"purple-4": `fhoQrasGZG`,
	"purple-5": `MmwFqb1oSv`,
	"purple-6": `Xbyb6x8e2R`,
	"black-1": `pznfI2X3BY`,
	"black-2": `OPkm3Xivq9`,
	"black-3": `lAKYy4AG2L`,
	"black-4": `nCv76CsBtE`,
	"black-5": `xlJP4XETdH`,
	"black-6": `jtwbIGp_pZ`,
	"picker-theme": `r_uehcoZBs`,
	"arrow-regular": `hHFvb3BWsO`,
	"notifications-modal__header--root": `RYHQTH10NW`,
	"notifications-modal__header--icon": `JQ0RODxDbv`,
	"notifications-modal__header--title": `UV__gLNk9W`,
	"notification-modal__container": `MJ3fHrYQmo`,
	"notifications-modal__root": `XsezbgaYew`,
	"notifications-modal__input-ctn": `GkJECQSelE`,
	"notifications-modal__title": `gvP1JrEFWE`,
	"notifications-modal__title--ctn": `uyjxWlkbVx`,
	"title--label": `rKUdE4Lrlv`,
	"title__icon-ctn": `AeSin2D8EH`,
	"title__icon": `g9AjJvDGCn`,
	"required-label": `xeV_oAt0GH`,
	"subject-input__input": `WQm7AGmeus`,
	"subject-input__input--error": `e88Nd8waC_`,
	"notifications-modal__message": `_aiWiUSBG2`,
	"notifications-modal__message--error": `sw_LiLcjfw`,
	"notifications-modal__alert-text": `B057YWZlWq`,
	"notify-user-options__label": `_BK1mppXqz`
};
export default ___CSS_LOADER_EXPORT___;
